import clsx from 'clsx';
import DownloadIcon from '../../assets/icons/download.svg?react';
import { install, useBeforeInstall, useInstall } from '../../utils/useInstall';
import { Button } from '../Button';
import styles from './DownloadButton.module.css';
import { LFC } from '../../types';

interface DownloadButtonProps {
  className?: string;
}

export const DownloadButton: LFC<DownloadButtonProps> = ({
  className,
  children,
}) => {
  const decision = useInstall();
  const beforeInstall = useBeforeInstall();

  if (!beforeInstall || decision) return null;

  return (
    <Button
      className={clsx(styles.btn, className)}
      variant="text"
      onClick={install}
    >
      {children} <DownloadIcon className={styles.icon} />
    </Button>
  );
};
